import { AVATARS } from '../lib/utils';

export default function AvatarStack({ avatarIndices = [], maxShow = 4, size = 32 }) {
  const shown = avatarIndices.slice(0, maxShow);
  const overflow = avatarIndices.length - maxShow;

  return (
    <div className="flex items-center">
      {shown.map((idx, i) => {
        const avatar = AVATARS[idx % AVATARS.length];
        return (
          <div
            key={i}
            className="rounded-full border-2 border-navy-900 flex items-center justify-center font-bold text-white transition-transform hover:scale-110 hover:z-10"
            style={{
              width: size,
              height: size,
              background: avatar.bg,
              marginLeft: i === 0 ? 0 : -(size * 0.3),
              fontSize: size * 0.4,
              position: 'relative',
              zIndex: shown.length - i,
              boxShadow: '0 0 0 2px #090e1a',
            }}
            title={`Avatar ${idx + 1}`}
          >
            {avatar.emoji}
          </div>
        );
      })}
      {overflow > 0 && (
        <div
          className="rounded-full border-2 border-navy-900 flex items-center justify-center font-bold text-white/60 text-xs"
          style={{
            width: size,
            height: size,
            background: 'rgba(255,255,255,0.08)',
            marginLeft: -(size * 0.3),
            boxShadow: '0 0 0 2px #090e1a',
          }}
        >
          +{overflow}
        </div>
      )}
    </div>
  );
}
